<div
  #dropdownContainer
  class="custom-dropdown"
  [ngClass]="{ open: dropdownOpen, disabled: disabled }"
  [class]="extraClasses"
>
  <div class="dropdown-toggle" (click)="toggleDropdown()" [ngClass]="{ placeholder: value === '' }">
    <span *ngIf="value === ''; else selectedRegion">{{ placeholder }}</span>
    <ng-template #selectedRegion>
      <div class="selected-region-display">
        <span class="region-name">{{ getSelectedRegionName(value) }}</span>
        <span class="region-slug">{{ value }}</span>
      </div>
    </ng-template>
    <i class="fa-utility fa-semibold fa-angle-down dropdown-arrow" [ngClass]="{ rotated: dropdownOpen }"></i>
  </div>
  <div class="dropdown-menu" *ngIf="dropdownOpen">
    <div class="search-container">
      <input
        #searchInput
        type="text"
        class="search-input"
        placeholder="Search regions..."
        [value]="searchTerm"
        (input)="onSearchInput($event)"
        (keydown)="onSearchKeydown($event)"
        autocomplete="off"
      />
      <i class="fa-utility fa-semibold fa-magnifying-glass search-icon"></i>
    </div>
    <div class="dropdown-items-container">
      <ng-container *ngIf="filteredRegions$ | async as regions; else loadingSpinner">
        <div
          class="dropdown-item"
          *ngFor="let region of regions"
          (click)="selectRegion(region)"
          [ngClass]="{
            selected: region.value === value,
            disabled: isRegionDisabled(region),
          }"
        >
          <div class="region-display">
            <span class="region-name">{{ getRegionNameOnly(region.label) }}</span>
            <span class="region-slug">{{ region.value }}</span>
          </div>
        </div>
        <div class="no-results" *ngIf="regions.length === 0 && searchTerm">
          No regions found matching "{{ searchTerm }}"
        </div>
      </ng-container>
      <ng-template #loadingSpinner>
        <div class="loading-spinner">
          <i class="fa fa-spinner fa-spin"></i>
          <span>Loading regions...</span>
        </div>
      </ng-template>
    </div>
  </div>
</div>
